<template>
  <div class="container" id="container">
    <!-- 头部banner -->
    <top-banner></top-banner>
    <!-- 轮播 -->
    <div class="banner_video" id="video_carouse">
      <el-carousel :interval="4000" class="carouselH" loop arrow="never">
        <el-carousel-item v-for="(item,index) in video" :key="index">
          <!-- <video width="100%" height="100%" v-if="index==0" loop :autoplay="item.auto" custom-cache="false">
            <source :src="item.url" type="video/mp4" />
          </video> -->
          <video-player v-if="index==0" class="video-player vjs-custom-skin" ref="videoPlayer" :playsinline="true"
            :options="playerOptions"></video-player>

          <img v-else :src="item.url" class="carouselImg" />
        </el-carousel-item>
      </el-carousel>
    </div>
    <!-- 占位撑开 -->
    <div class="zw"></div>
    <!-- 点服环境成就 -->
    <div class="index_item1">
      <img src="@/common/images/index/index_item1_title.png" class="i_item1_title" />
      <div class="i_item1_content">
        <div class="content_item" v-for="(item,index) in hjcj" :key="index">
          <div class="content_item_t">
            <img :src="item.url" class="cj_img" v-show="active1" :class="{ 'bounceInDown': active1 }" v-if="index==2" />
            <img :src="item.url" class="cj_img" v-show="active1" :class="{ 'bounceInLeft': active1 }"
              v-else-if="index==0||index==1" />
            <img :src="item.url" class="cj_img" v-show="active1" :class="{ 'bounceInRight': active1 }" v-else />
          </div>
          <div class="content_item_b">
            <div class="dw">{{item.dw}}</div>
            <div class="line_num" v-show="active1" :class="{ 'bounceInUp': active1 }">{{item.num}}</div>
            <div class="line_title" v-show="active1" :class="{ 'bounceInUp': active1 }">{{item.title}}</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 我们的产品 -->
    <div class="index_item2">
      <img src="@/common/images/index/index_item2_bg.png" class="index_item2_bg" />
      <div class="item2_box">
        <img src="@/common/images/index/index_item2_title.png" class="i_item2_title" />
        <div class="cp_item" v-for="(item,index) in cpList" :key="index">
          <img :src="item.imgUrl" :class="item.claImg" @mouseover="item.show=true" @mouseout="item.show=false" />
          <transition name="el-zoom-in-top" v-if="index==3||index==4">
            <img :src="item.titleUrl" v-show="item.show" :class="item.claTitle" />
          </transition>
          <transition name="el-zoom-in-center" v-else>
            <img :src="item.titleUrl" v-show="item.show" :class="item.claTitle" />
          </transition>
        </div>
      </div>
    </div>
    <!-- 新闻中心 -->
    <div class="index_item3">
      <img src="../common/images/index/dot_img.png" class="dot_img" />
      <div class="item3_title">新闻中心</div>
      <div class="item3_banner">
        <div class="i3_banner_item" v-for="(item,index) in item3Banner" :key="index" :class="{'isSelect':item.isSelect}"
          @click="changeItem3(index)">{{item.title}}</div>
      </div>
      <div class="item3_content" id="news_carouse">
        <el-carousel :interval="4000" type="card" indicator-position="outside" class="newsH">
          <el-carousel-item v-for="(item,index) in item3Content" :key="index">
            <div class="i3_card">
              <img :src="item.coverPlan" class="card_img" />
              <div class="card_news">
                <div class="i3c_title">{{item.title}}</div>
                <div class="i3c_content">{{item.intro}}</div>
                <div class="i3c_detail" @click="goDetail(item.id)">查看详情</div>
              </div>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
    <!-- 企业资质 -->
    <div class="index_item4">
      <div class="item4_title">企业资质</div>
      <div class="item4_content">
        <vue-seamless-scroll :data="item4List" :class-option="defaultOption">
          <div class="i4_content_item" v-for="(item,index) in item4List" :key="index">
            <img :src="item.imgUrl" class="i4_item_img" />
            <div class="i4_item_title">{{item.title}}</div>
          </div>
        </vue-seamless-scroll>

      </div>
    </div>
    <!-- 项目案例 -->
    <div class="index_item5">
      <img src="../common/images/index/index_item5_bg.png" class="i5_img" />
      <img src="../common/images/index/i5_topbg.png" class="i5_topbg" :class="{ 'transition': testShow }" />
      <div class="i5_title">项目案例</div>
    </div>
    <!-- 联系我们 -->
    <div class="index_item6">
      <img src="../common/images/index/index_item6_bg.png" class="i6_img" />
      <div class="i6_l">
        <img src="../common/images/index/i6_ll1.png" class="ll1" :class="{ 'transition_i6_1': showi6 }" />
        <img src="../common/images/index/i6_ll2.png" class="ll2" :class="{ 'transition_i6_2': showi6 }" />
        <!-- <img src="../common/images/index/i6_ll3.png" class="ll3" :class="{ 'transition_i6_3': showi6 }" /> -->
        <img src="../common/images/index/i6_ll4.png" class="ll4" :class="{ 'transition_i6_4': showi6 }" @click="aboutUs()" />
      </div>
      <div class="i6_r">
        <img src="../common/images/index/i6_rbg1.png" class="rbg1" />
        <img src="../common/images/index/i6_rbg2.png" class="rbg2" />
        <div class="i6_rb">
          <img src="../common/images/index/i6_rl1.png" class="rl1" :class="{ 'transition_i6_r1': showi6 }" />
          <img src="../common/images/index/i6_rl2.png" class="rl2" :class="{ 'transition_i6_r2': showi6 }" />
          <img src="../common/images/index/i6_rl3.png" class="rl3" :class="{ 'transition_i6_r3': showi6 }" />
        </div>
      </div>
    </div>
    <!-- 尾部banner -->
    <btm-banner></btm-banner>
  </div>
</template>

<script>
  import axios from 'axios'
  import topBanner from '@/components/topBanner.vue'
  import btmBanner from '@/components/btmBanner.vue'
  import VueSeamlessScroll from "vue-seamless-scroll"
  import {
    videoPlayer
  } from 'vue-video-player'
  import 'video.js/dist/video-js.css'
  import 'vue-video-player/src/custom-theme.css'
  export default {
    name: 'index',
    components: {
      topBanner,
      btmBanner,
      VueSeamlessScroll
    },
    data() {
      return {
        video: [{
          url: require('@/assets/banner_item2.mp4'),
          auto: true
        }, {
          url: require('@/assets/banner_item2.png'),
          auto: true
        }, {
          url: require('@/assets/banner_item3.png'),
          auto: true
        }],
        hjcj: [{
          url: require('@/common/images/index/cj_ldxm.png'),
          dw: '个',
          num: '7',
          title: '自营改厕项目'
        }, {
          url: require('@/common/images/index/cj_syrm.png'),
          dw: '人',
          num: '400+',
          title: '管护人员'
        }, {
          url: require('@/common/images/index/cj_hjcyz.png'),
          dw: '户',
          num: '30万+',
          title: '受益居民'
        }, {
          url: require('@/common/images/index/cj_ldcs.png'),
          dw: '个',
          num: '80+',
          title: '信息化项目'
        }, {
          url: require('@/common/images/index/cj_sb.png'),
          dw: '台',
          num: '3万+',
          title: '在管物联网设备'
        }],
        cpList: [{
          imgUrl: require('@/common/images/index/cp_ddfl_logo.png'),
          titleUrl: require('@/common/images/index/cp_ddfl_title.png'),
          claImg: 'ddfl_logo',
          claTitle: 'ddfl_title',
          show: false,
        }, {
          imgUrl: require('@/common/images/index/cp_dzhg_logo.png'),
          titleUrl: require('@/common/images/index/cp_dzhg_title.png'),
          claImg: 'dzhg_logo',
          claTitle: 'dzhg_title',
          show: false,
        }, {
          imgUrl: require('@/common/images/index/cp_cggj_logo.png'),
          titleUrl: require('@/common/images/index/cp_cggj_title.png'),
          claImg: 'cggj_logo',
          claTitle: 'cggj_title',
          show: false,
        }, {
          imgUrl: require('@/common/images/index/cp_gc_logo.png'),
          titleUrl: require('@/common/images/index/cp_gc_title.png'),
          claImg: 'gc_logo',
          claTitle: 'gc_title',
          show: false,
        }, {
          imgUrl: require('@/common/images/index/cp_zhhw_logo.png'),
          titleUrl: require('@/common/images/index/cp_zhhw_title.png'),
          claImg: 'zhhw_logo',
          claTitle: 'zhhw_title',
          show: false,
        }, {
          imgUrl: require('@/common/images/index/cp_ljfl_logo.png'),
          titleUrl: require('@/common/images/index/cp_ljfl_title.png'),
          claImg: 'ljfl_logo',
          claTitle: 'ljfl_title',
          show: false,
        }],
        item3Banner: [{
          title: '公司新闻',
          isSelect: true
        }, {
          title: '通知公告',
          isSelect: false
        }, {
          title: '信息报送',
          isSelect: false
        }],
        item3Content: [],
        item4List: [{
          imgUrl: require('@/common/images/index/zy1.jpg'),
          title: '计算机软件著作权登记证书'
        }, {
          imgUrl: require('@/common/images/index/zy2.jpg'),
          title: '计算机软件著作权登记证书'
        }, {
          imgUrl: require('@/common/images/index/zy3.jpg'),
          title: '计算机软件著作权登记证书'
        }, {
          imgUrl: require('@/common/images/index/zy4.jpg'),
          title: '计算机软件著作权登记证书'
        }, {
          imgUrl: require('@/common/images/index/zy5.jpg'),
          title: '计算机软件著作权登记证书'
        }, {
          imgUrl: require('@/common/images/index/zy6.jpg'),
          title: '计算机软件著作权登记证书'
        }],
        currentScroll: 0,
        testShow: false,
        showi6: false,
        zoomValue: 0,
        active1: false,
        curPage: '/',
      }
    },
    computed: {
      defaultOption() {
        return {
          step: 1, // 数值越大速度滚动越快
          limitMoveNum: 1, // 开始无缝滚动的数据量 this.item4List.length
          hoverStop: true, // 是否开启鼠标悬停stop
          direction: 2, // 0向下 1向上 2向左 3向右
          openWatch: true, // 开启数据实时监控刷新dom
          singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
          // waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
        }
      },
      playerOptions() {
        const playerOptionsObj = {
          playbackRates: [0.7, 1.0, 1.5, 2.0], //视频播放速度
          autoplay: true, // 如果true，浏览器准备好时开始回放。
          muted: false, // 默认情况下将会消除任何音频。
          loop: true, // 导致视频一结束就重新开始。
          // preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）。
          language: 'zh-CN',
          // aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）。
          fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
          sources: [{
            type: 'video/mp4', // 资源格式写法：'video/mp4'，否则控制台会出现notSupportedMessage设置的错误。
            src: this.video[0].url // 视频url地址
          }],
          notSupportedMessage: '此视频暂无法播放...', // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
          controlBar: false,
        }
        return playerOptionsObj
      }
    },
    mounted() {
      window.addEventListener('scroll', this.handleScrollbox, true)
      var browerWidth = window.innerWidth; //浏览器可视宽度
      var baseWidth = 1920; //设计稿宽度
      this.zoomValue = browerWidth / baseWidth; //缩放比例计算
      window.onresize = function() { //窗口尺寸变化时，重新计算和缩放
        browerWidth = window.innerWidth;
        this.zoomValue = browerWidth / baseWidth;
      }
      this.getNewsTop()
    },
    methods: {
      handleScrollbox() {
        this.currentScroll = window.pageYOffset //表示当前滚动的位置
        var browerWidth = window.innerWidth; //浏览器可视宽度
        var baseWidth = 1920; //设计稿宽度
        this.zoomValue = browerWidth / baseWidth; //缩放比例计算
        if (this.currentScroll >= 540 * this.zoomValue) {
          this.active1 = true
        }
        if (this.currentScroll >= 3600 * this.zoomValue) {
          this.testShow = true
        }
        if (this.currentScroll < 2800 * this.zoomValue) {
          this.testShow = false
        }
        if (this.currentScroll > 4000 * this.zoomValue) {
          this.showi6 = true
        }

      },
      changeItem3(e) {
        for (var i = 0; i < 3; i++) {
          this.item3Banner[i].isSelect = false
        }
        this.item3Banner[e].isSelect = true
      },
      goDetail(e) {
        this.$router.push({
          path: '/newsDetail',
          query: {
            id: e
          }
        })
      },
      aboutUs(){
        this.$router.push({
          path: '/aboutUs'
        })
      },

      getNewsTop() {
        var url = 'http://kjhsx.diandifenlei.com/RecycleBin/news/getNewsHost'
        axios({
          method: 'get',
          url: url
        }).then(({
          data
        }) => {
          if (data.code == 200) {
            this.item3Content = data.data
          }
        })
      },
    },
    beforeDestroy() {
      window.removeEventListener('scroll', this.handleScrollbox, true)
    },
  }
</script>

<style>
  @import '../common/css/index.css';

  #video_carouse .el-carousel__container {
    width: 1920px;
    height: 1080px;
  }

  #news_carouse .el-carousel__container {
    width: 1920px;
    height: 392px;
  }

  .el-carousel__indicators--horizontal {
    bottom: 32px !important;
  }

  .el-carousel__indicators--outside {
    margin-top: 32px !important;
  }

  .el-carousel__arrow--left {
    left: 336px !important;
  }

  .el-carousel__arrow--right {
    right: 336px !important;
  }

  .el-carousel__arrow {
    width: 78px !important;
    height: 78px !important;
    background-color: #ffffff80 !important;
    color: #8d8d8d !important;
    font-size: 28px !important;
  }

  .el-carousel__arrow:hover {
    background-color: #ffffff !important;
  }

  .carouselH {
    width: 1920px;
    height: 1080px;
  }

  .carouselImg {
    width: 1920px;
    height: 1080px;
  }

  .newsH {
    width: 1920px;
    height: 502px;
  }

  .video-player {
    width: 1920px;
    height: 1080px;
  }

  .vjs-control-bar {
    display: none !important;
  }

  .video-js.vjs-ended .vjs-big-play-button,
  .video-js.vjs-paused .vjs-big-play-button,
  .vjs-paused.vjs-has-started.vjs-custom-skin>.video-js .vjs-big-play-button {
    display: none !important;
  }

  .vjs-custom-skin>.video-js {
    pointer-events: none !important;
  }

  #vjs_video_3 {
    width: 1920px !important;
    height: 1080px !important;
  }
</style>



// WEBPACK FOOTER //
// src/views/index.vue